export default "__VITE_ASSET__4a4BW$2L__"